mutation EntityDocumentRetireBalance(
  $input: EntityDocumentRetireBalanceInput!
) {
  entityDocumentRetireBalance(input: $input) {
    entityDocument {
      id
      _rowTimestamp
      _revisePrivilege
      _unretirePrivilege
      _retirePrivilege
      fileIndexInformation
      _documentContents
      comment
      entityDocumentTypeId
      indexTransactionDate
      indexName
      indexDescription
      indexReferenceNumber
      indexAmount
      indexCurrencyId
      extractionTypeId
      indexTaxAccount1
      indexTaxAmount1
      indexTaxCode1
      indexTaxAccount2
      indexTaxAmount2
      indexTaxCode2
      indexTaxAccount3
      indexTaxAmount3
      indexTaxCode3
      indexTaxAccount4
      indexTaxAmount4
      indexTaxCode4
      documentFileDistributionsByDocumentFileId {
        nodes {
          id
          _isDeletable
          _rowTimestamp
          accountReference
          additionalDescription
          distributionAmount
          projectReference
          setReference
          referenceCode1
          referenceCode2
          referenceCode3
          referenceCode4
          referenceCode5
          tax1099T4TypeId
          referenceCode6
          referenceCode7
          distributionDate
        }
      }
      extractionType {
        isExtractProtected
      }
      lookupName {
        lookupName
        id
        isApprovedVendor
        lookupCode
        lookupName
        lookupName2
        address1
        address2
        city
        state
        zipCode
        country
        phone
        emailAccount
      }
    }
    approvalEntityDocument {
      id
    }
  }
}
